var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 38 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#201D1E",
    d: "M37.895 12c0-.292-.177-.68-.357-.869L27.433.394a1.265 1.265 0 0 0-1.786-.049c-.492.443-.504 1.306-.05 1.786l8.113 8.606H1.263a1.263 1.263 0 1 0 0 2.526H33.71l-8.112 8.605c-.455.48-.422 1.323.05 1.787.497.49 1.32.445 1.785-.05l10.105-10.737c.297-.29.352-.571.357-.868"
  })));
};
export default SvgArrow;